import { CombineRoutes as Routes } from '@routes';
import { themeOptions } from '@theme';

import { createTheme, CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { useNotifier } from '@hooks/use-notifier';

import { Locales } from '@managers/locales';
import { ErrorBoundary } from '@managers/logging/error-boundary';
import { PageTitlesManager } from '@managers/page-titles';

import NavigationScroll from '@widgets/layout/navigation-scroll';

function App() {
  useNotifier();
  const theme = createTheme(themeOptions());

  return (
    <ErrorBoundary>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Locales>
            <PageTitlesManager />

            <NavigationScroll>
              <Routes />
            </NavigationScroll>
          </Locales>
        </ThemeProvider>
      </StyledEngineProvider>
    </ErrorBoundary>
  );
}

export default App;
